// src/data/resumeData.js
// All personal information and resume data centralized in one file

const resumeData = {
	personalInfo: {
		name: "Mason DiGiorgio",
		title: "Computer Engineering Student & Developer",
		email: "mdigiorgio@vt.edu",
		linkedin: "linkedin.com/in/masondigiorgio",
		github: "github.com/MasonDiGi",
		github2: "github.com/MasonDiGi-VT",
		gitlab: "git.masondigi.com/mason/",
		education: {
			school: "Virginia Tech",
			location: "Blacksburg, VA",
			degree: "Computer Engineering Major, Computer Science Minor",
			gpa: "3.9 GPA",
			graduation: "May 2026",
		},
	},

	skills: {
		languages: [
			"Python",
			"C/C++",
			"Embedded C",
			"Bash",
			"Java",
			"MATLAB",
			"Swift",
			"Javascript/Typescript",
			"SQL",
			"HTML/CSS",
		],
		developerTools: [
			"Linux/Unix",
			"Debian",
			"Arch Linux",
			"Fedora",
			"Docker",
			"Altium Designer",
			"Azure DevOps",
			"Proxmox Hypervisor",
			"Solidworks",
			"Fusion 360",
			"Computer Networking",
			"Git",
			"GitHub",
			"Nginx",
			"Home Assistant",
		],
		physicalTools: [
			"Soldering",
			"3D printing",
			"Raspberry Pi",
			"Robotics",
			"Server Installation",
		],
		awards: [
			"VTHacks 12 Best IoT Hack (2024)",
			"VTHacks 11 Best UI/UX (2023)",
			"HackViolet Best Visionary Hack (2023)",
		],
		other: ["High Voltage Trained", "CPR Certified"],
	},

	experience: [
		{
			company: "Nokia Bell Labs",
			location: "Murray Hill, NJ",
			position: "Robotics Co-op",
			period: "Spring 2025",
			achievements: [
				"Improved existing software for custom robotics networking using eBPF and C/C++",
				"Packaged and automated deployment of multiple applications using Debian packages",
			],
		},
		{
			company: "Moog Inc.",
			location: "Blacksburg, VA",
			position: "Computer Science Intern",
			period: "Summer 2024",
			achievements: [
				"Developed and maintained custom applications for internal use",
				"Communicated with customers to detect and fix bugs before they entered production",
			],
		},
		{
			company: "Nokia Bell Labs",
			location: "Murray Hill, NJ",
			position: "Robotics Intern",
			period: "Summer 2023",
			achievements: [
				"Automated OS deployment for an aftermarket add-on board for Omron and MIR robots",
				"Learned how to operate said robots with a custom overlay network",
				"Created a custom local subnet and used a layer 2 tunnel to connect a PXE boot server to newly created boards",
			],
		},
		{
			company: "Long Hill Township School District",
			location: "Long Hill, NJ",
			position: "Technology Intern",
			period: "Summer 2022",
			achievements: [
				"Assisted the school's IT department over the summer to prepare for the school year",
				"Configured servers and desktop computers for the school district",
			],
		},
	],

	clubExperience: [
		{
			organization: "BOLT at Virginia Tech",
			location: "Blacksburg, VA",
			position: "Controls Lead",
			period: "2022-Present",
			achievements: [
				"Wrote complete firmware for a custom distributed BMS using the L9963E BMIC",
				"Programmed a microcontroller for a custom-built electric motorcycle, communicating with CAN and UART",
				"Created a custom dashboard for a rider",
			],
		},
	],

	projects: [
		{
			name: "Proxmox Home Server",
			slug: "proxmox-server",
			description: [
				"Purchased a used Dell server and installed Proxmox VE",
				"Setup Proxmox to run several virtual machines and containers",
				"Streamlined the process of adding websites to a reverse proxy",
			],
			longDescription:
				"This project involved setting up a complete home lab infrastructure using a repurposed Dell PowerEdge R720 running Proxmox VE. The server hosts various services including websites, development environments, and home automation systems in isolated virtual machines and containers. It also makes it extremely easy to test software and development environments quickly. Finally, it is being used to learn Linux Kernel Development without worrying about destroying a bare metal machine.",
			features: [
				"Self-hosted virtualization platform running multiple services",
				"Reverse proxy setup for secure remote access to services",
				"Automated backups and snapshots for disaster recovery",
				"Resource monitoring and management using Proxmox built-in tools",
				"Improve workflows for adding test environments and websites",
			],
			technologies: ["Proxmox VE", "Linux", "LXC", "NGINX", "Docker"],
			image: "/images/proxmox.png",
			tags: ["Infrastructure", "Virtualization", "Linux"],
		},
		{
			name: "Custom GitLab instance - git.masondigi.com",
			slug: "gitlab-instance",
			description: [
				"Installed the community edition of GitLab and set it up",
				"Use it to store several of my programming projects as an alternative to GitHub",
			],
			longDescription:
				"I set up a self-hosted GitLab CE instance to manage my private repositories and provide a complete CI/CD pipeline for my projects. This gives me full control over my source code while learning about DevOps practices and infrastructure management.",
			features: [
				"Self-hosted Git repository management",
				"Custom CI/CD pipelines for automated testing and deployment",
				"Self-hosted runners to compile for Windows, Linux, and anything else",
				"Honestly it's just cool and fun",
			],
			technologies: ["GitLab CE", "CI/CD"],
			image: "/api/placeholder/800/400",
			demoUrl: "https://git.masondigi.com/explore",
			tags: ["DevOps", "Git", "Self-hosted"],
		},
		{
			name: "Personal Website - masondigi.com",
			slug: "personal-website",
			description: [
				"Created and ran a personal website using ReactJS",
				"Runs on an LXC container and is exported through an NGINX reverse proxy",
				"Wow! It's the website you're looking at right now!",
			],
			longDescription:
				"My personal website serves as a portfolio where I can have a more interactive and long-form way to show my interests and accompishments. In the future, I plan to use this as a hub for all my personal projects, and it can be used as great documentation for what I have done in the past.",
			features: [
				"Custom WordPress theme development",
				"Portfolio showcase with detailed project pages",
				"Technical blog with syntax highlighting for code snippets",
				"Optimized for performance with caching and CDN integration",
				"Responsive design that works on all device sizes",
			],
			technologies: [
				"WordPress",
				"PHP",
				"MySQL",
				"NGINX",
				"HTML/CSS",
				"JavaScript",
				"Let's Encrypt",
			],
			image: "/images/personal-website.png",
			demoUrl: "https://masondigi.com",
			tags: ["Web", "NGINX", "WordPress"],
		},
		{
			name: "HomeAssistant Server",
			slug: "home-assistant",
			description: [
				"Created and ran a local HomeAssistant server connect together multiple smart devices in my home",
				"Configured to control pins on a remote microcontroller or smart lights from Apple's Homekit, Alexa, or Google Home",
			],
			longDescription:
				"My Home Assistant setup integrates various smart home devices and custom-built IoT solutions into a single management platform. This includes both commercial devices and custom microcontroller projects I've built for specific needs around my home.",
			features: [
				"Centralized control of smart home devices",
				"Custom automations based on time, presence, and sensor data",
				"Integration with voice assistants (Alexa, Google Home, Siri)",
				"Custom-built sensors using ESP32/ESP8266 microcontrollers",
				"Energy usage monitoring and optimization",
				"Secure remote access from anywhere",
			],
			technologies: [
				"Home Assistant",
				"MQTT",
				"ESP32",
				"Node-RED",
				"Zigbee",
				"Docker",
				"Python",
			],
			image: "/api/placeholder/800/400",
			githubUrl: "https://github.com/MasonDiGi/home-automation",
			tags: ["IoT", "Smart Home", "Automation"],
		},
	],
};

export default resumeData;
